import { Pipe, PipeTransform } from '@angular/core';
import { BusStopAppEntityBusStopWrite } from '../openapi';

@Pipe({
  name: 'busStopLabel',
  standalone: true
})
export class BusStopLabelPipe implements PipeTransform {
  public transform(v?: BusStopAppEntityBusStopWrite | null): string {
    if (v) {
      return `Numer drogi: ${v.roadNumber || '-'}, Nr przystanku: ${v.stopNumber || '-'}`;
    } else {
      return '';
    }
  }
}
